"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowContainer = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const label_1 = __importDefault(require("../label"));
const styles_1 = require("../../styles");
const use_form_1 = require("../../form/use-form");
exports.RowContainer = styled_1.default.div `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: 100%;
  ${styles_1.mixins.rowWidth}
`;
const InputContainer = styled_1.default.div `
  @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: flex;
    align-items: ${(props) => props.alignItems || 'unset'};
  }
`;
/**
 * Renders a row of inputs.
 */
const InputRow = ({ path, label, isRequired, width, flexGrowSizes, children, breakpoints: fieldBreakpointsConfig, isVisible, alignInputs }) => {
    const { context: { breakpoints: globalBreakpoints, isRequiredMarker, isNotRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    if (isVisible === false)
        return null;
    const inputs = react_1.default.Children.map(children, (child, index) => {
        if (child === null)
            return;
        return (react_1.default.createElement(styles_1.FieldStyles, { breakpoints: fieldBreakpointsConfig || globalBreakpoints, flexGrow: flexGrowSizes ? flexGrowSizes[index] : 1 }, child));
    });
    return (react_1.default.createElement(exports.RowContainer, { "data-testid": "row", width: width, breakpoints: fieldBreakpointsConfig || globalBreakpoints },
        label ? (react_1.default.createElement(label_1.default, { isRequired: isRequired, id: path ? `${path}-label` : undefined, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker }, label)) : null,
        react_1.default.createElement(InputContainer, { alignItems: alignInputs, breakpoints: fieldBreakpointsConfig || globalBreakpoints }, inputs)));
};
InputRow.propTypes = {
    label: prop_types_1.default.string,
    isRequired: prop_types_1.default.bool,
    width: prop_types_1.default.oneOf(['xl', 'l', 'm', 's']),
    flexGrowSizes: prop_types_1.default.array,
    breakpoints: prop_types_1.default.object,
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.element,
        prop_types_1.default.arrayOf(prop_types_1.default.element)
    ]),
    path: prop_types_1.default.string,
    isVisible: prop_types_1.default.bool,
    alignInputs: prop_types_1.default.string
};
exports.default = InputRow;
//# sourceMappingURL=row.js.map